import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import genericSupplierClient from 'Services/Apis/Spot/genericSupplierClient';
import redemptionsApiClient from 'Services/Apis/Spot/redemptionsClient';

const initialState = {
  isVisibleDifal: false,
  isVisibleModalDifalTerms: false,
  createPDF: null,
  isLoadingPDF: false,
  isLoadingSpot: false,
  isErrorSpot: false,
  isValidToCheckout: true,
  quote: null,
  termUrl: null,
  dataSpot: {},
  userData: {},
};

export const loadDataSpot = createAsyncThunk(
  `ApproveHierarchySlice/loadDataSpot`,
  async (payload) => {
    const { data } = await redemptionsApiClient.get(
      `/Redemption/${payload.redemptionId}`,
      {
        headers: payload.headers,
      }
    );

    return data;
  }
);

export const loadUserInfos = createAsyncThunk(
  'ApproveHierarchySlice/loadUserInfos',
  async (payload, { getState }) => {
    const { dataSpot } = getState().SpotApproveHierarchy;
    console.log('payload======>', dataSpot);

    const { data: dataUsername } = await redemptionsApiClient.get(
      `/Participant/${payload.participantId}`,
      {
        headers: payload.headers,
      }
    );

    const { data: dataSubSegmento } = await genericSupplierClient.get(
      `/api/ParticipantGroup?participantId=${payload.participantId}`,
      {
        headers: payload.headers,
      }
    );

    const { data: dataBalance } = await redemptionsApiClient.get(
      `/Participant/balance?participantId=${payload.participantId}&username=${dataUsername.username}`,
      {
        headers: payload.headers,
      }
    );

    return {
      ...dataSpot,
      user: dataUsername,
      grupos: dataSubSegmento,
      balance: dataBalance,
    };
  }
);

const ApproveHierarchySlice = createSlice({
  name: 'ApproveHierarchySlice',
  initialState: initialState,
  reducers: {
    setIsVisibleDifalModal(state, action) {
      state.isVisibleModalDifalTerms = action.payload;
    },
    setTermUrl(state, action) {
      state.termUrl = action.payload;
    },
    setIsValidToCheckout(state, action) {
      state.isValidToCheckout = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(loadUserInfos.pending, (state, action) => {
      state.isLoadingPDF = true;
    });

    builder.addCase(loadUserInfos.fulfilled, (state, action) => {
      state.userData = {
        ...action.payload,
        ...action.payload.user,
        ...action.payload.grupos,
        ...action.payload.balance,
      };
      state.isLoadingPDF = false;
    });
    builder.addCase(loadUserInfos.rejected, (state, action) => {
      console.log('loadUserInfos.rejected', action);
    });

    builder.addCase(loadDataSpot.pending, (state, action) => {
      state.isLoadingSpot = true;
      state.isErrorSpot = false;
    });
    builder.addCase(loadDataSpot.fulfilled, (state, action) => {
      state.dataSpot = action.payload;
      state.quote = action.payload?.files[0];
      state.isLoadingSpot = false;
    });
    builder.addCase(loadDataSpot.rejected, (state, action) => {
      console.log('loadDataSpot.rejected', action);
      state.isErrorSpot = true;
    });
  },
});

export const { setIsVisibleDifalModal, setTermUrl, setIsValidToCheckout } =
  ApproveHierarchySlice.actions;
export default ApproveHierarchySlice.reducer;
